module.exports = __webpack_public_path__ + "media/images/front/premium_lp/bg_title_01-91be2fd8eb16b2a5ca98918210100f5b.png";